import axios from 'axios';

const getList = params => axios.get('/projetos', {
  params,
});
const get = id => axios.get(`/projetos/${id}`, {});

const save = (projeto) => {
  if (projeto.id) {
    return axios.put(`/projetos/${projeto.id}`, projeto);
  }
  return axios.post('/projetos', projeto);
};

const remover = id => axios.delete(`/projetos/${id}`);

export default {
  getList,
  get,
  save,
  remover,
};
